export const API_URL = {
    iclass: import.meta.env.VITE_ICLASS_API_URL,
    survey: import.meta.env.VITE_SURVEY_API_URL
}
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID
export const SURVEY_KEY = import.meta.env.VITE_SURVEY_KEY
export const ENDPOINT = {
    iclass: {
        //Student
        studentLogin: '/Auth/student/login',
        studentInfo: '/Student/user-info',
        studentClassDetails: '/Student/iclass/detail',
        studentClassContent: '/Student/iclass/content',
        submitAudioVocab: '/Student/iclass/submit-audio',


        //Teacher
        teacherLogin: '/Auth/teacher/login',
        teacherInfo: '/Teacher/user-info',
        teacherClassList: '/Teacher/iclass/list',
        teacherClassDetails: '/Teacher/iclass/detail',
        teacherClassContent: '/Teacher/iclass/content',

        //ETC
        hub: '/IclassHub',
        setting: {
            base: '/setting',
            version: '/setting/version'
        }
    }
}